/** Created by azhou on 2019/4/4.*/
<template>
  <div class="p-3 text-left h6">
    <div class="d-center-start mb-4"><left-text leftText="订单号" class="pb-3"/>
      <div class="w-100 border-bottom ml-5 pb-3 text-muted">
        <label>{{OrderDetail.oid}}</label>
        <span class="ml-5" v-if="OrderDetail.appoint>0">定向酒店 - {{OrderDetail.appointName || OrderDetail.store_name}}</span>
        <span class="ml-5" v-if="isGroup && OrderDetail.appoint<=0">{{OrderDetail.store_name}}</span>
      </div>
    </div>
    <div class="d-start-start mb-4" v-if="OrderSuccess"><left-text leftText="订单支付"/>
      <div class="ml-5 w-100">
        <div v-for="(item,index) in SuccessHotel" :key="item.id" class="mb-1 text-center d-center">
          <div class="w-100">
            <!--<p class="font-weight-bold pb-2">{{item.title}}</p>-->
            <div class="border d-center-between">
              <div class="w-50 border-right pt-2 pb-2">订单总额：
                <span class="text-danger">{{(item.totalPrice*100 + item.continued_pay)/100 | formatMoney}}</span>元
                <span class="text-link ml-2" @click="changePrice(8,item)" v-if="userInfo.type!==2 && $GFUN.isInArray([7,8],OrderDetail.status)">修改</span>
              </div>
              <div class="w-50 border-right pt-2 pb-2">订金</div><div class="w-50">尾款</div>
              <div class="w-50 border-left pt-2 pb-2" v-if="item.continued_price>0">续住</div>
            </div>
            <div class="border-left border-right border-bottom d-center-between">
              <div class="w-50 border-right pt-2 pb-2">需付</div>
              <div class="w-50 border-right pt-2 pb-2">{{item.deposit | formatMoney}} 元
                <span class="text-link ml-2" @click="changePrice(7,item)" v-if="showChangeDeposit(item)">修改</span>
              </div>
              <div class="w-50">{{item.price | formatMoney}} 元</div>
              <div class="w-50 border-left pt-2 pb-2" v-if="item.continued_price>0">
                {{item.continued_price | formatMoney}} 元
                <span class="text-link ml-2" @click="changePrice(9,item)" v-if="userInfo.type!==2">修改</span>
              </div>
            </div>
            <div class="d-center-between border-left border-right border-bottom">
              <div class="w-50  border-right pt-2 pb-2">已付</div>
              <div class="w-50  border-right pt-2 pb-2"> <span class="text-success">{{item.deposit_pay/100 | formatMoney}}</span>  元</div>
              <div class="w-50"><span class="text-success">{{item.price_pay/100 | formatMoney}}</span>  元</div>
              <div class="w-50  border-left pt-2 pb-2" v-if="item.continued_price>0"> <span class="text-success">{{item.continued_pay/100 | formatMoney}}</span>  元</div>
            </div>
            <div class="d-center-between border-left border-bottom" v-if="item.offline_pay > 0 && item.status == 9">
              <div class="w-100  border-right pt-2 pb-2">线下支付：{{item.offline_pay/100 | formatMoney}}&nbsp;&nbsp;元</div>
            </div>
          </div>
          <div class="d-flex flex-column ml-4" v-if="showPayBtn(item)">
            <el-input type="number" placeholder="请输入金额" step="0.01" v-model.number="item.setPayPrice" class="mb-2">
              <template slot="append">元</template>
            </el-input>
            <el-button @click="showPayQRCode(item,index)" type="success">生成支付码</el-button>
          </div>
          <img v-show="PayQRCode && currentIndex===index"
               class="ml-3 border p-1 rounded" style="height: 150px;" :src="PayQRCode">
        </div>
      </div>
    </div>
    <div class="d-center-start mb-4"><left-text leftText="用房区域" class="pb-3"/>
      <div class="w-100 border-bottom ml-5 pb-3 text-muted">
        <label>{{OrderDetail.province_name}}省{{OrderDetail.city_name}}市</label>
        <span v-for="item in OrderDetail.county_name" class="ml-2" :key="item">{{item}}</span>
      </div>
    </div>
    <div class="d-start-start mb-4" v-if="roomArr&&roomArr.length>0"><left-text leftText="用房需求"/>
      <div class="w-100 border-bottom ml-5 pb-2">
        <div v-for="item in roomArr" :key="item.id" class="d-center-start mb-1 text-muted">
          <left-text :leftText="$options.filters['formatVar'](item.type,'roomStyle')"/><label>{{item.room_num}} 间</label>
          <p class="ml-3" v-if="userInfo.type===3 && item.showPrice">
            {{item.room_price/item.room_num | formatMoney}}
            元 / 晚 &nbsp;&nbsp;可提供{{item.room_num}}间&nbsp;&nbsp;
            <span v-show="item.type!==4">房间：{{item.room_meeting_name}}</span>
          </p>
        </div>
        <div class="d-center-start text-muted">
          <left-text leftText="早餐"/>{{OrderDetail.breakfast | formatVar('breakfastArr')}}
        </div>
      </div>
    </div>
    <div class="d-start-start mb-4" v-if="meetArr&&meetArr.length>0"><left-text leftText="会议室需求"/>
      <div class="ml-5 border-bottom pb-2">
        <div v-for="item in meetArr" :key="item.id" class="d-center-start mb-1 text-muted">
          <left-text :leftText="$options.filters['formatVar'](item.layout,'LayoutTypes')"/>
          {{item.date | formatTimestamp()}}{{item.timeslot | formatVar('TimeSlots')}}
          <label v-if="userInfo.type===3" class="ml-1 mr-1">{{item.meeting_price}}元</label>
          <label class="ml-2 mr-2" v-if="item.led===2">LED
            <label v-if="userInfo.type===3" class="ml-1 mr-1">{{item.led_price}}元</label>
          </label>
          <label class="ml-2 mr-2" v-if="item.projector===2">投影仪
            <label v-if="userInfo.type===3" class="ml-1 mr-1">{{item.projector_price}}元</label>
          </label>
        </div>
        <div class="d-center-start mb-1 text-muted" v-if="OrderDetail.is_meal>0">
          <left-text leftText="用餐"/>
          {{OrderDetail.is_meal | formatVar('mealType')}}
          <label v-if="userInfo.type===3 && OrderDetail.is_meal>0" class="ml-1 mr-1">
            {{OrderDetail.meal_price}}元 / {{OrderDetail.is_meal===1 ? '人':'桌起'}}
          </label>
        </div>
        <div class="d-center-start text-muted" v-if="OrderDetail.tea_break > 0">
          <left-text leftText="茶歇"/>需要
          <label v-if="userInfo.type===3" class="ml-1 mr-1">{{OrderDetail.tea_break_price}}元</label>
        </div>
      </div>
    </div>
    <div class="d-center-start" v-if="OrderDetail.remark">
      <left-text leftText="备注" class="pb-3"/>
      <span class="ml-5 text-muted border-bottom w-100 pb-3">{{OrderDetail.remark}}</span>
    </div>
  </div>
</template>

<script>
  import { mapGetters,mapState,mapActions } from 'vuex'

  export default {
    name: 'HotelOrderCard',
    computed: {
      ...mapState(['OrderDetail','HotterOfferLists','newMessageInform','choose']),
      ...mapGetters(['storeInfo','isAdmin','userInfo','isGroup']),
      OrderSuccess() {
        return this.$GFUN.isInArray([7,8,9],this.OrderDetail.status)
      },
      SuccessHotel() {
        let arr = [];
        switch (this.userInfo.type) {
          case 2:arr =  this.choose; break;
          case 3:
            let o = this.OrderDetail;
            arr =  [{
              totalPrice: o.price,
              deposit: o.deposit,
              deposit_pay: o.deposit_pay,
              price: (o.price * 100 - o.deposit * 100) / 100,
              price_pay: Number(o.price_pay) - Number(o.deposit_pay),
              continued_price: o.continued_price,
              continued_pay: o.continued_pay,
              status: o.status,
              hotel_id: o.store_id,
              oid: o.oid,
              title:o.store_name,
              offline_pay:o.offline_pay
            }];
            let v = arr[0];
            switch (o.status) {
              case 7: v.setPayPrice = ((v.deposit * 100 - v.deposit_pay) / 100).toFixed(2); break;
              case 8: v.setPayPrice = ((v.price * 100 - v.price_pay) / 100).toFixed(2); break;
              case 9: v.setPayPrice = ((v.continued_price * 100 - v.continued_pay) / 100).toFixed(2); break;
              default: v.setPayPrice = 0;
            }
            v.needPay = v.setPayPrice;
            break;
          case 99: arr =  this.HotterOfferLists.filter(v => this.$GFUN.isInArray([7,8,9],v.status)); break;
          default :return [];
        }
        if (this.$GFUN.isInArray([2],this.userInfo.type)) {
          arr.forEach(v => {
            let t = v.order_price_details || {};
            switch (v.status) {
              case 7: v.setPayPrice = ((t.book_price * 100 - t.book_pay) / 100).toFixed(2); break;
              case 8: v.setPayPrice = ((t.total_price * 100 - t.total_pay) / 100).toFixed(2); break;
              case 9: v.setPayPrice = ((t.continued_price * 100 - t.continued_pay) / 100).toFixed(2); break;
              default: v.setPayPrice = 0;
            }
            v.needPay = v.setPayPrice;
            v.price = (t.total_price * 100 - t.book_price * 100) / 100
            v.price_pay = Number(t.total_pay) - Number(t.book_pay);
            v.deposit_pay = t.book_pay;
            v.continued_pay = t.continued_pay;
            v.continued_price = t.continued_price;
          });
        }
        if (this.$GFUN.isInArray([99],this.userInfo.type)) {
          arr = arr.map(v => {
            return {
              ...v,
              price: (v.price * 100 -  v.deposit * 100) / 100,
              price_pay:(v.price_pay * 100 - v.deposit_pay * 100) / 100,
              totalPrice: (v.totalPrice * 100 - v.continued_price * 100) / 100
            };
          })
        }
        return arr;
      },
      roomArr() {
        switch (this.userInfo.type) {
          case 3:
            if (!this.OrderDetail.hotel_offer) return []
            let arr = this.OrderDetail.hotel_offer.filter(v => v.order_room_meeting_type === 1);
            arr.forEach(v => {
              v.type = v.room_meetimg_style;
              v.showPrice = true
            });
            //酒店没有参加报价，此时arr为空数组
            if (arr.length <= 0) {
              arr = this.OrderDetail.roomArr;
              arr.forEach(v => v.showPrice = false);
            }
            return arr;
          case 2:
          case 99: return this.OrderDetail.roomArr;
          default :return [];
        }
      },
      meetArr() {
        switch (this.userInfo.type) {
          case 3:
            if (!this.OrderDetail.hotel_offer) return []
            let arr = this.OrderDetail.hotel_offer.filter(v => v.order_room_meeting_type === 2);
            arr.forEach(v => {
              v.layout = v.room_meetimg_style;
              let meetObj =  this.OrderDetail.meetArr.filter(s => s.id === v.order_meeting_id)[0] || {};
              v.time = meetObj.time;
              v.timeslot = meetObj.timeslot;
            })
            return arr;
          case 2:
          case 99: return this.OrderDetail.meetArr;
          default :return [];
        }
      },
    },
    watch: {
      newMessageInform(newVal) {
        if (newVal && newVal.type === 12) {
          //若待付金额为0，触发父组件刷新一次订单列表
          if (this.SuccessHotel[this.currentIndex].setPayPrice <= 0) this.$emit('getOrderList',true);
          this.PayQRCode = '';
          let id = this.SuccessHotel[this.currentIndex].oid || this.OrderDetail.id;
          this.GetOrderDetail(id)
          if (this.userInfo.type === 2) this.GetOfferMess(id);
        }
      }
    },
    data() {
      return {
        PayQRCode:'',
        currentIndex:''
      }
    },
    methods:{
      ...mapActions(['GetOfferMess','ChangeHotelPrice','GetOrderDetail']),
      showPayBtn (item) {
        let t = item.order_price_details || {};
        let p = t.continued_price * 100, v = t.continued_pay
        let continuePrice = p - v > 0
        switch (this.storeInfo.type) {
          case 2:
            return this.$GFUN.isInArray([7, 8], item.status) || continuePrice
          case 3:
            return this.$GFUN.isInArray([8], item.status) || continuePrice
          default:
            return false
        }
      },
      showChangeDeposit(item) {
        let t = this.userInfo.type !== 2,
          s = this.$GFUN.isInArray([7,8],this.OrderDetail.status),
        m = item.deposit == 0 || (item.deposit_pay < item.deposit * 100);
        return t && s && m;
      },
      //生成支付二维码
      showPayQRCode (item,index) {
        this.currentIndex = index;
        if (!this.$GFUN.isMoneyRight(item.setPayPrice)) { this._alert('金额有误！',null,'error'); return }
        // if (item.setPayPrice < 10) { this._alert('支付金额不得少于10元！'); return }
        if (item.setPayPrice > item.needPay) { this._alert('支付金额不应超过应付金额！',null,'error'); return }
        this.PayQRCode = this.$GFUN.producePayQRCode({
          hotelId: item.hotel_id || item.storeId,
          orderId: item.oid || this.OrderDetail.id,
          type: item.status,
          priceFen: (item.setPayPrice * 100).toFixed(0),
          orderPayId: item.hotel_oid || this.OrderDetail.id
        });
      },
      //修改订金、尾款，添加续住
      changePrice(type,item) {
        let tip = '';
        switch (type) {
          case 7: tip = `当前订金：${item.deposit}元    请设置订金(金额不得少于已付金额)`; break;
          case 8: tip = `当前订单总额：${(item.totalPrice*100 + item.continued_pay)/100}元    请设置订单金额（包含订金）`; break;
          case 9: tip =  '设置续住'; break;
        }
        this.$prompt('请输入金额', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder:tip,
          inputPattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
          inputErrorMessage: '金额格式不正确'
        }).then(({ value }) => {
          let data = {
            oid: this.OrderDetail.oid || this.OrderDetail.id
          }
          switch (type) {
            case 7:data.book_price = Number(value).toFixed(2); break
            case 8:data.edit_total_price = Number(value).toFixed(2); break
            case 9:data.continued_price = Number(value).toFixed(2); break
            default:break;
          }
          if (this.isAdmin) data.store_id = item.hotel_id
          this.ChangeHotelPrice({
            type:'hotel',
            data,
            successFun:() => { this.$emit('getOrderList',true) }
          });
        }).catch(() => {});
      },
    }
  }
</script>
